var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          attrs: {
            title: "SOLICITAR CANCELAMENTO",
            subtitle:
              "Digite abaixo os dados para abrir um ticket de cancelamento",
            size: "md"
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submit($event)
                  }
                }
              },
              [
                _vm.advanceTime()
                  ? _c("div", [
                      _c(
                        "h3",
                        { staticClass: "observation" },
                        [
                          _c("b", [
                            _vm._v("Atenção!"),
                            _c("br"),
                            _vm._v(
                              "Existem algumas regras quando o cancelamento \n              é solicitado com menos de 48h de antecedência."
                            )
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              attrs: { to: { name: "help" } },
                              nativeOn: {
                                click: function($event) {
                                  _vm.sendEvents("help")
                                }
                              }
                            },
                            [_vm._v("Veja as regras aqui\n              ")]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.firstStep
                  ? _c(
                      "div",
                      [
                        _c("p", [
                          _vm._v(
                            "Por favor, você pode nos dizer um pouquinho do por que você deseja cancelar? :)"
                          )
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.why,
                              expression: "why"
                            }
                          ],
                          attrs: {
                            placeholder:
                              "Conte-nos aqui por que você deseja cancelar...",
                            rows: "5"
                          },
                          domProps: { value: _vm.why },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.why = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("base-flex", { staticClass: "mt-25" }, [
                          _c(
                            "div",
                            {
                              staticClass: "btn bg-purple-outline",
                              on: {
                                click: function($event) {
                                  _vm.$emit("close")
                                }
                              }
                            },
                            [_vm._v("cancelar solicitação")]
                          ),
                          _vm._v(" "),
                          _vm.isABoletoPayment(_vm.paymentType)
                            ? _c(
                                "div",
                                {
                                  staticClass: "btn bg-purple",
                                  attrs: { type: "submit" },
                                  on: {
                                    click: function($event) {
                                      _vm.hiddenFirstStep()
                                      _vm.showLastStep()
                                    }
                                  }
                                },
                                [_vm._v("avançar")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isABoletoPayment(_vm.paymentType)
                            ? _c(
                                "div",
                                {
                                  staticClass: "btn bg-purple",
                                  class: { "btn--loading": _vm.loader },
                                  attrs: {
                                    type: "submit",
                                    disabled: _vm.disableSendTicketButton
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.submit()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      !_vm.loader
                                        ? "solicitar cancelamento"
                                        : ""
                                    ) + "\n          "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.lastStep
                  ? _c(
                      "div",
                      [
                        _c("p", { staticClass: "bankDetails" }, [
                          _vm._v(
                            "\n          Para agilizar o reembolso do seu cancelamento, \n          como o pagamento foi feito via boleto bancário, \n          precisamos dos dados de uma conta bancária vinculado ao "
                          ),
                          _c("b", [_vm._v(_vm._s(_vm.getDocumentType()))])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "div",
                            [
                              _c("InputGroup", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  error: _vm.errors.first("nome do banco"),
                                  name: "bank",
                                  label: "nome do banco"
                                },
                                model: {
                                  value: _vm.bank,
                                  callback: function($$v) {
                                    _vm.bank = $$v
                                  },
                                  expression: "bank"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("InputGroup", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  error: _vm.errors.first("agência"),
                                  name: "agency",
                                  label: "agência"
                                },
                                model: {
                                  value: _vm.agency,
                                  callback: function($$v) {
                                    _vm.agency = $$v
                                  },
                                  expression: "agency"
                                }
                              }),
                              _vm._v(" "),
                              _c("InputGroup", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  error: _vm.errors.first(
                                    "número da conta com dígito"
                                  ),
                                  name: "accountNumberWithDigit",
                                  label: "número da conta com dígito"
                                },
                                model: {
                                  value: _vm.accountNumberWithDigit,
                                  callback: function($$v) {
                                    _vm.accountNumberWithDigit = $$v
                                  },
                                  expression: "accountNumberWithDigit"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("base-flex", { staticClass: "mt-30" }, [
                          _c(
                            "div",
                            {
                              staticClass: "btn bg-purple-outline",
                              on: {
                                click: function($event) {
                                  _vm.$emit("close")
                                }
                              }
                            },
                            [_vm._v("cancelar solicitação")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn bg-purple",
                              class: { "btn--loading": _vm.loader },
                              attrs: {
                                type: "submit",
                                disabled: _vm.disableSendTicketButton
                              },
                              on: {
                                click: function($event) {
                                  _vm.submit()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  !_vm.loader ? "solicitar cancelamento" : ""
                                ) + "\n            "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c("success-dialog", {
        attrs: { visible: _vm.successDialogVisibility },
        on: {
          close: function($event) {
            _vm.closeSuccessDialog()
            _vm.closeCancellationDialog()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62a9b598", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62a9b598","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Freshdesk/Cancellation/Why.vue
// module id = null
// module chunks = 